const touchUtils = {
    startTime: undefined,
    endTime: undefined,

    mouseDown() {
        this.startTime = new Date().getTime();
    },
    mouseUp() {
        this.endTime = new Date().getTime();
    },
    isLongInteraction() {
        if (isNaN(this.endTime) || isNaN(this.startTime))
            return false;
        else {
            var time = this.endTime - this.startTime;

            if (time > 300)
                return true;
            else
                return false;
        }
    }
};

export default touchUtils;



/** WEBPACK FOOTER **
 ** ./src/components/utils/TouchUtils.js
 **/